import React from 'react';
import { isEmpty } from 'lodash';
import { HStack, CircularProgress, List } from '@medely/ui-kit';

import { IPayout } from '@medely/types';
import { PayoutListItem } from './PayoutListItem';
import { useProNavigate } from '../../contexts/NavigationContext';
import { useEarningsEvent } from '../../hooks';
import { EmptyState } from '../EmptyState';
import { HelpCenterLink } from '../helpCenterLink';

type PayoutsListProps = {
  isLoading: boolean;
  month: Date;
  payouts: IPayout[];
};

export const PayoutsList = ({ isLoading, month, payouts }: PayoutsListProps) => {
  const { navigate } = useProNavigate();
  const { trackEarningsPayoutListItemClicked } = useEarningsEvent();

  if (isLoading) {
    return (
      <HStack justifyContent="center" py={8}>
        <CircularProgress />
      </HStack>
    );
  } else if (isEmpty(payouts)) {
    return (
      <EmptyState
        title={`No ${month.toLocaleString('default', { month: 'long' })} payouts`}
        description={
          'Per diem payouts are processed on Mondays, Wednesdays, or Fridays unless held for review. ' +
          'Assignment timesheets are typically processed on Tuesday for shifts in the previous week.'
        }
        linkComponent={<HelpCenterLink configKey="learnAboutPayouts" text="Learn about payouts" />}
      />
    );
  }

  return (
    <List
      items={payouts}
      keyFn={(payout) => payout.id}
      showDivider
      render={(payout) => {
        return (
          <PayoutListItem
            variant="detailed"
            payout={payout}
            onClick={() => {
              trackEarningsPayoutListItemClicked({ payout_id: payout.id });
              navigate('EarningsPayoutDetails', { id: payout.id });
            }}
          />
        );
      }}
    />
  );
};
